"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Main;
var jsx_runtime_1 = require("react/jsx-runtime");
var models_1 = require("../../lib/models");
var LNumOutp_1 = require("../client/inputs/body/LNumOutp");
var SoilDiv_1 = require("./SoilDiv");
var CalcBtn_1 = require("../client/buttons/CalcBtn");
var App_1 = require("../../App");
var Invite_1 = require("../client/content/Invite");
var ap = {
    n: "agr_plaster",
    t: "Gesso Agrícola",
};
var swf = {
    n: "sw_flour",
    t: "Farinha de Algas",
};
var firstInpBlockDef = [
    {
        n: "peat",
        t: "Turfa",
    },
    {
        n: "perlite",
        t: "Perlita",
    },
    {
        n: "earthworm_humus",
        t: "Húmus de Minhoca",
    },
];
var secondInpBlockDef = [
    {
        n: "basalt_rp",
        t: "Pó de Rocha Basalto",
    },
    {
        n: "neem_pie",
        t: "Torta de Neem",
    },
    {
        n: "shell_ls",
        t: "Calcário de Conchas",
    },
    ap,
];
var secondInpBlockB = __spreadArray(__spreadArray([], secondInpBlockDef, true), [
    {
        n: "bokashi",
        t: "Bokashi",
    },
    {
        n: "biochar",
        t: "Biochar",
    },
], false);
function Main() {
    return ((0, jsx_runtime_1.jsxs)("main", { id: "main", children: [(0, jsx_runtime_1.jsx)("img", { id: "soilSacs", alt: "Sacos de Solo", src: "https://blog.organolab.com.br/wp-content/uploads/2024/09/sacos_solo_redc.png", width: 527, height: 197 }), (0, jsx_runtime_1.jsxs)("hgroup", { id: "calc-title-group", children: [(0, jsx_runtime_1.jsx)("h1", { className: "calc-title-parts", id: "calc-title", children: "Calculadora de Solo" }), (0, jsx_runtime_1.jsxs)("h2", { className: "calc-title-parts", id: "calc-title-brand", children: [(0, jsx_runtime_1.jsx)("strong", { children: App_1.keyPhrase.slice(0, -1) }), (0, jsx_runtime_1.jsx)("abbr", { className: "copyright-icon", children: App_1.keyPhrase.slice(-1) })] })] }), (0, jsx_runtime_1.jsxs)("div", { id: "invite-logo-wrapper", children: [(0, jsx_runtime_1.jsx)("img", { id: "invite-logo-img", alt: "Logo para An\u00FAncio", src: "https://blog.organolab.com.br/wp-content/uploads/2024/09/org_lab_logo_favicon_96.png", width: 86, height: 84 }), (0, jsx_runtime_1.jsx)(Invite_1.default, {})] }), (0, jsx_runtime_1.jsx)(SoilDiv_1.default, {}), (0, jsx_runtime_1.jsx)("div", { id: "kits-wrapper", children: [
                    {
                        kn: "Coots Soil",
                        sub: [
                            {
                                o: "first",
                                inps: firstInpBlockDef,
                            },
                            {
                                o: "second",
                                inps: __spreadArray(__spreadArray([], secondInpBlockDef, true), [swf], false),
                            },
                        ],
                    },
                    {
                        kn: "Matinho Cheiroso | Solo Vivo",
                        sub: [
                            { o: "first", inps: firstInpBlockDef },
                            {
                                o: "second",
                                inps: __spreadArray(__spreadArray([], secondInpBlockB, true), [
                                    swf,
                                    {
                                        n: "cr_flour",
                                        t: "Farinha de Crustáceos",
                                    },
                                ], false),
                            },
                        ],
                    },
                    {
                        kn: "GYNETCS",
                        sub: [
                            { o: "first", inps: firstInpBlockDef },
                            {
                                o: "second",
                                inps: __spreadArray(__spreadArray([], secondInpBlockB, true), [
                                    {
                                        n: "nt_phosp",
                                        t: "Fosfato Natural",
                                    },
                                ], false),
                            },
                        ],
                    },
                ].map(function (s, i) {
                    var normalizedKn = (0, models_1.regularToCamel)(s.kn.replace(/\|/g, " ").replace(/\s{2,}/g, " "));
                    var pascalKn = (0, models_1.regularToPascal)(s.kn.replace(/\|/g, " ").replace(/\s{2,}/g, " "));
                    if (/[A-Z]/g.test(normalizedKn)) {
                        normalizedKn = /[A-Z]/g.test(normalizedKn.charAt(0))
                            ? normalizedKn.slice(0, /[A-Z\_\-]/g.exec(normalizedKn.slice(1)).index)
                            : normalizedKn.slice(0, /[A-Z\_\-]/g.exec(normalizedKn.slice(0)).index);
                    }
                    return ((0, jsx_runtime_1.jsxs)("section", { id: "sect".concat(pascalKn), className: "kit-sect", "data-title": "Kit \u2014 ".concat(s.kn), "data-group": normalizedKn, children: [(0, jsx_runtime_1.jsxs)("h3", { className: "kit-title", id: "title".concat(pascalKn), "data-group": normalizedKn, children: ["Kit \u2014 ", s.kn] }), s.sub.map(function (sc, j) { return ((0, jsx_runtime_1.jsx)("div", { className: "kit-subsect coots-soil-subsect", id: "div".concat(j).concat(pascalKn), "data-group": normalizedKn, children: sc.inps.map(function (inp, k) { return ((0, jsx_runtime_1.jsx)(LNumOutp_1.default, { name: inp.n, id: /_/g.test(inp.n)
                                        ? "".concat((0, models_1.kebabToCamel)(inp.n), "Sect").concat(pascalKn)
                                        : "".concat(inp.n, "Sect").concat(pascalKn), title: "".concat(inp.t, "__").concat(s.kn), iniValue: s.kn === "GYNETCS" && j === 1 ? "kg" : "l", group: normalizedKn }, "kit_sect__".concat(i, "__subsect__").concat(j, "__inp__").concat(k))); }) }, "kit_sect__".concat(i, "__subsect__").concat(j))); }), (0, jsx_runtime_1.jsx)(CalcBtn_1.default, { id: pascalKn, group: normalizedKn })] }, "kit_sect__".concat(i)));
                }) })] }));
}
